import { SuggestedAgendaItemModel } from "models/SuggestedAgendaItemModel";
import { createContext } from "react";

export interface SuggestedAgendaItemPanelContextProps {
  isOpen: boolean;
  isLoading: boolean;
  isSubmitting: boolean;
  isDeleting: boolean;
  isForm: boolean;
  filterText: string;
  submitMessage: string | undefined;
  selectedIds: Set<number>;
  items: SuggestedAgendaItemModel[];
  filteredItems: SuggestedAgendaItemModel[];
  setFilterText: (text: string) => void;
  openPanel: () => void;
  closePanel: () => void;
  onItemChange: (id: number, selected: boolean) => void;
  onMove: () => void;
  onDelete: () => void;
}

export const SuggestedAgendaItemPanelContext = createContext({} as SuggestedAgendaItemPanelContextProps);
